import React, { useEffect, useState } from 'react';
import api from 'api/api';
import auth from 'utils/auth';
import Loader from 'ui/Loader/Loader';
import NoBeneficiary from 'components/modules/Beneficiaries/NoBeneficiary/NoBeneficiary';
import BeneficiaryTable from 'components/modules/Beneficiaries/BeneficiaryTable/BeneficiaryTable';
import BeneficiaryRow from 'components/modules/Beneficiaries/BeneficiaryTable/BeneficiaryRow/BeneficiaryRow';
import BeneficiaryCol from 'components/modules/Beneficiaries/BeneficiaryTable/BeneficiaryCol/BeneficiaryCol';
import { IApiBeneficiaryPrepaidCardResponse, IBeneficiaryPrepaidCard } from './SinglePrepaidBen.model';
import EditPrepaidCardBen from './EditPrepaidCardBen';

enum States {
  browsing = 'browsing',
  editing = 'editing',
}

const SinglePrepaidBen = () => {
  const [loadingData, setLoadingData] = useState(false);
  const [data, setData] = useState<IBeneficiaryPrepaidCard[]>([]);
  const [editData, setEditData] = useState<IBeneficiaryPrepaidCard | null>(null);

  const [state, setState] = useState<States>(States.browsing);

  const fetchBeneficiaries = () => {
    setLoadingData(true);
    api
      .get(`/beneficiary/prepaidcard?loginId=${auth.data?.loginId || ''}`)
      .then((response: IApiBeneficiaryPrepaidCardResponse) => {
        setData(response.beneficiaries);
      })
      .catch((error) => {
        console.error(error);
        setData([]);
      })
      .finally(() => {
        setLoadingData(false);
      });
  };

  useEffect(() => {
    fetchBeneficiaries();
  }, []);

  const openEditForm = (e: React.MouseEvent<HTMLDivElement>) => {
    setState(States.editing);
    const object = data.find(({ id }) => id === Number(e.currentTarget.id));
    if (object) {
      setEditData(object);
    }
  };

  const closeEditForm = () => {
    setState(States.browsing);
    fetchBeneficiaries();
  };

  if (state === States.editing && editData) {
    return <EditPrepaidCardBen data={editData} onClose={closeEditForm} />;
  }

  const renderTable = () => (
    <BeneficiaryTable>
      {data.map((beneficiary) => (
        <BeneficiaryRow onClick={openEditForm} id={String(beneficiary.id)} key={beneficiary.id}>
          <BeneficiaryCol label="Full Name" value={beneficiary.name} width="10%" minWidth="250px" />
          <BeneficiaryCol label="Customer ID" value={beneficiary.cardCustomerId} width="10%" minWidth="200px" />
          <BeneficiaryCol label="Card Name" value={beneficiary.cardName} width="10%" minWidth="200px" />
          <BeneficiaryCol label="Phone Number" value={beneficiary.phoneNumber} width="10%" minWidth="200px" />
          <BeneficiaryCol label="Card’s Last 4 Digits" value={beneficiary.last4digit} width="100%" minWidth="400px" />
        </BeneficiaryRow>
      ))}
    </BeneficiaryTable>
  );

  return (
    <>
      {loadingData && <Loader fullHeight />}
      {!loadingData && data.length === 0 && <NoBeneficiary />}
      {!loadingData && data.length > 0 && renderTable()}
    </>
  );
};

export default SinglePrepaidBen;
